import { createSlice } from "@reduxjs/toolkit";

const initialState = {

    loading: false,

    notifications: [],

    unreadCount: 0,

    selectedNotification: null,

    drawerOpen: false,

    error: null
};

const marketplaceNotificationSlice = createSlice({

    name: "marketplaceNotifications",

    initialState,

    reducers: {

        loadNotificationsStart(state) {

            state.loading = true;
            state.error = null;
        },

        loadNotificationsSuccess(state, action) {

            state.loading = false;

            state.notifications = action.payload;

            state.unreadCount = action.payload.filter(

                n => !n.read

            ).length;
        },

        loadNotificationsFailure(state, action) {

            state.loading = false;

            state.error = action.payload;
        },

        appendNotification(state, action) {

            state.notifications.unshift(action.payload);

            if (!action.payload.read) {

                state.unreadCount++;
            }
        },

        markNotificationRead(state, action) {

            const notification = state.notifications.find(

                n => n.id === action.payload

            );

            if (notification && !notification.read) {

                notification.read = true;

                if (state.unreadCount > 0) {

                    state.unreadCount--;
                }
            }
        },

        markAllNotificationsRead(state) {

            state.notifications.forEach(

                n => n.read = true

            );

            state.unreadCount = 0;
        },

        removeNotification(state, action) {

            state.notifications =

                state.notifications.filter(

                    n => n.id !== action.payload

                );

            state.unreadCount =

                state.notifications.filter(

                    n => !n.read

                ).length;
        },

        clearNotifications(state) {

            state.notifications = [];

            state.unreadCount = 0;
        },

        openNotificationDrawer(state) {

            state.drawerOpen = true;
        },

        closeNotificationDrawer(state) {

            state.drawerOpen = false;
        },

        selectNotification(state, action) {

            state.selectedNotification = action.payload;
        },

        clearSelectedNotification(state) {

            state.selectedNotification = null;
        }

    }

});

export const {

    loadNotificationsStart,

    loadNotificationsSuccess,

    loadNotificationsFailure,

    appendNotification,

    markNotificationRead,

    markAllNotificationsRead,

    removeNotification,

    clearNotifications,

    openNotificationDrawer,

    closeNotificationDrawer,

    selectNotification,

    clearSelectedNotification

} = marketplaceNotificationSlice.actions;

export default marketplaceNotificationSlice.reducer;